import React from "react"
import {Tippy} from "partials/Tippy"
import {BoundComponent} from "utils/react"

export class Popover extends BoundComponent {
  state = {isOpen: false}
  open() {
    this.setState({isOpen: true})
  }
  close() {
    this.setState({isOpen: false})
  }
  render() {
    const {children, ...props} = this.props
    const {isOpen} = this.state

    return (
      <Tippy isOpen={isOpen} appendTo="parent" {...props}>
        <span onMouseEnter={this.open} onMouseLeave={this.close}>
          {children}
        </span>
      </Tippy>
    )
  }
}
